import { getBill, updateBill, deleteBill, createBill } from '@/api/bill'
import Vue from 'vue'

const state = {
  billList: [],
  totalCounts: 0,
}

const actions = {
  async getBillAction({ commit }, payload) {
    try {
      const billList = await getBill(payload);
        commit('SET_BILL_LIST', billList.data)
        return billList.data
    } catch (error) {
      throw error.message
    }
  },
  async getBillByIDAction({ commit }, payload) {
    try {
      const bill = await getBillByID(payload)
      return bill.data
    } catch (error) {
      throw error.message
    }
  },
  async createBillAction({ commit }, payload) {
    try {
      const bill = await createBill(payload);
      commit('ADD_BILL', bill.data)
      return bill.data
    } catch (error) {
      throw error.message
    }
  },
  async updateBillAction({ commit }, payload) {
    try {
      const bill = await updateBill(payload.id, payload.data)
      commit('UPDATE_BILL', bill.data)
      return bill.data
    } catch (error) {
      throw error.message
    }
  },
  async deleteBillAction({ commit }, payload) {
    try {
      await deleteBill(payload)
      commit('DELETE_BILL', payload)
    } catch (error) {
      throw error.message
    }
  }
}

const mutations = {
  SET_BILL_LIST(state, payload) {
    state.billList = payload.list;
    state.totalCounts = payload.totalCounts
  },
  ADD_BILL(state, bill) {
    state.billList.unshift(bill)
    state.totalCounts++
  },
  DELETE_BILL(state, id) {
    state.billList = state.billList.filter(e => e._id !== id)
    state.totalCounts--
  },
  UPDATE_BILL(state, bill) {
    Vue.set(state.billList, state.billList.findIndex(x => x._id === bill._id), bill)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}